export const MINI_VALUATOR_LAST_VISITED_STOCK_KEY =
  'miniValuatorLastVisitedStock';

export const setLastVisitedStockForMiniValuator = (canonicalUrl: string) => {
  sessionStorage.setItem(
    MINI_VALUATOR_LAST_VISITED_STOCK_KEY,
    JSON.stringify({ canonicalUrl, timestamp: Date.now() })
  );
};
export const removeLastVisitedStockForMiniValuator = () => {
  sessionStorage.removeItem(MINI_VALUATOR_LAST_VISITED_STOCK_KEY);
};

export const getLastVisitedStockForMiniValuatorInThePastHour = ():
  | string
  | null => {
  if (typeof window === 'undefined') return null;
  try {
    const rawString = sessionStorage.getItem(
      MINI_VALUATOR_LAST_VISITED_STOCK_KEY
    );
    if (!rawString) return null;

    const { canonicalUrl, timestamp } = JSON.parse(rawString);

    if (Date.now() - timestamp > 60 * 60 * 1000) return null;

    return /^\/stocks\/[^/]+\/[^/]+\/[^/]+\/[^/]+$/.test(canonicalUrl)
      ? canonicalUrl
      : null;
  } catch (e) {
    return null;
  }
};
